// src/context/AppProviders.js - VERSÃO COMPLETA
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './auth/AuthProvider';
import { AlertProvider } from './alert/AlertProvider';

// Configuração do QueryClient
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutos
            cacheTime: 1000 * 60 * 10, // 10 minutos
            retry: 1,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: 1,
        },
    },
});

// Componente para tratamento de erros globais
const ErrorBoundary = ({ children }) => {
    // Em produção, você pode implementar um ErrorBoundary real aqui
    return children;
};

const AppProviders = ({ children }) => {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <AlertProvider>
                        {children}
                    </AlertProvider>
                </AuthProvider>
                {process.env.NODE_ENV === 'development' && (
                    <ReactQueryDevtools 
                        initialIsOpen={false} 
                        position="bottom-right" 
                    />
                )}
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

export default AppProviders;